import React from 'react';
import classnames from 'classnames';

import Icon from 'components/atoms/Icon';

import IconDeco from 'images/icon/deco-slash.inline.svg';

import styles from './index.module.css';

interface SectionTitleProperty {
	className?: string;
	type?: 'primary' | 'category' | 'categoryWithIcon';
	align?: 'center' | 'right';
	size?: 'fixed-size-mobile-desktop' | 'normal';
	pattern?: 'primary' | 'reverse';
	iconSrc?: string;
	title: string;
	subTitle?: string;
}

const SectionTitle: React.FC<SectionTitleProperty> = ({
	className,
	type = 'primary',
	align = 'left',
	size = 'normal',
	pattern = 'primary',
	iconSrc = '',
	title,
	subTitle,
}) => {
	if (type === 'category') {
		return (
			<div
				className={classnames(
					className,
					styles.sectionTitle,
					styles[`type-${type}`],
					styles[`pattern-${pattern}`],
					{ [styles.fixedSizeMobileDesktop]: size === 'fixed-size-mobile-desktop' },
				)}
			>
				<IconDeco />
				<h3 className={styles.title}>{title}</h3>
				<IconDeco />
			</div>
		);
	}

	if (type === 'categoryWithIcon') {
		return (
			<div className={classnames(className, styles.sectionTitle, styles.typeCategoryWithIcon)}>
				{iconSrc && <Icon className={styles.icon} size="large" src={iconSrc} />}
				<h3 className={styles.title}>{title}</h3>
			</div>
		);
	}

	return (
		<div
			className={classnames(
				className,
				styles.sectionTitle,
				styles[`type-${type}`],
				styles[`align-${align}`],
				styles[`pattern-${pattern}`],
			)}
		>
			<h2 className={styles.title}>{title}</h2>
			<p className={styles.subTitle}>{subTitle}</p>
		</div>
	);
};

export default SectionTitle;
